import { UserCircleIcon } from '@heroicons/react/24/solid';
import {
  ArrowsRightLeftIcon,
  ComputerDesktopIcon,
  CreditCardIcon,
  QuestionMarkCircleIcon,
  TrophyIcon,
  UsersIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { NavLink } from 'react-router-dom';
import { useContext, useRef, useState, useEffect } from 'react';
import { TranslateContext } from '../../../Context/translate-context';
import ToggleTheme from 'Components/Common/ToggleTheme';
import useThemeStore from 'Theme/store';
import { inject, observer } from 'mobx-react';
import useChatStore from 'Components/Chat/store';
import DiscordModal from 'Components/DiscordModal';
import HelpModal from 'Components/HelpModal';
import ShortModal from 'Components/ShortModal';

const ProfileMenu = ({ 
  store,
}) => {
  const [openSettings, setOpenSettings] = useState(false);
  const [showTeamsModal, setShowTeamsModal] = useState(false);
  const [openDialogHelp, setOpenDialogHelp] = useState(false);
  const [openDialogDiscord, setOpenDialogDiscord] = useState(false);
  const [openDialogShort, setOpenDialogShort] = useState(false);
  const settingsRef = useRef(null);
  const profileRef = useRef(null);
  const { theme: themeValue } = useThemeStore();
  const context = useContext(TranslateContext);
  const setPowerPanelOpen = useChatStore((state) => state.setPowerPanelOpen);

  // List group of users LTD
  const LTDs = [
    'straico_tier1',
    'straico_tier2',
    'straico_tier3',
    'straico_tier4',
    'straico_tier5',
  ];

  // Handle User Guide activation for LTD
  const handleUserGuideOrModal = () => {
    if (LTDs.includes(store.profile.plan)) {
      window.userGuiding.previewGuide(140145);
    } else {
      setShowTeamsModal(true);
    }
  };

  const onInteraction = async (str) => {
    if (str === 'close') {
      setOpenDialogHelp(false);
      setOpenDialogDiscord(false);
      setOpenDialogShort(false);
    }
  };

  const fromColor = () => {
    if (store.profile.credits <= 0) {
      return 'bg-red-200 text-red-600';
    }
    if (store.profile.status === 'trialing') {
      return '';
    }
    if (store.profile.status === 'active') {
      return '';
    }
    if (store.profile.status === 'incomplete') {
      return '';
    }
    return 'bg-red-200 text-red-600';
  };

  const getImageProfile = () => store.profile.avatar?.svg;

  const handleClickOutside = (event) => {
    if (
      settingsRef.current &&
      !settingsRef.current.contains(event.target) &&
      profileRef.current &&
      !profileRef.current.contains(event.target)
    ) {
      setOpenSettings(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        ref={profileRef}
        onClick={() => setOpenSettings(!openSettings)}
        className={`flex px-1 cursor-pointer ${fromColor()} hover:bg-platinum rounded-md transition items-center dark:hover:bg-night-black max-md:hidden`}
      >
        {store.profile.avatar?.svg ? (
          <div className="avatar">
            <div className="w-10 rounded">
              <div
                dangerouslySetInnerHTML={{
                  __html: getImageProfile(),
                }}
              />
            </div>
          </div>
        ) : (
          <UserCircleIcon className="size-9 transition -mb-1 text-cool-gray dark:text-battleship-gray cursor-pointer" />
        )}
      </div>

      {openSettings && (
        <div
          ref={settingsRef}
          className={`${themeValue === 'dark' ? 'bg-night-black' : 'bg-white'
            } absolute top-[91.7%] right-3 p-5 rounded-xl shadow-[0_0_6.4px_#00000040] z-20 w-max`}
        >
          <div className="flex">
            <button
              onClick={() => {
                setOpenDialogDiscord(true);
                setOpenSettings(false);
              }}
              className={`flex items-center justify-center px-1 rounded-md text-sm ${themeValue === 'dark'
                ? 'hover:bg-ship-grey text-crystal-bell'
                : 'hover:bg-lavender text-cool-gray'
                }`}
            >
              <img
                className="h-4 px-1 block"
                src={
                  themeValue === 'dark'
                    ? '/svg/discord-mark-white.svg'
                    : '/svg/discord-mark-blue.svg'
                }
                alt="discord"
              />
            </button>
            <ToggleTheme />
            <a
              href="https://straico.com/multimodel/"
              target="_blank"
              rel="noreferrer"
              className="flex "
              onClick={() => setOpenSettings(false)}
            >
              <button
                className={`flex items-center justify-center px-1 rounded-md ${themeValue === 'dark'
                  ? 'text-crystal-bell hover:bg-ship-grey'
                  : 'text-raisin-black hover:bg-lavender'
                  }  text-sm`}
              >
                <QuestionMarkCircleIcon className="w-5 h-5 mx-1" />
              </button>
            </a>
          </div>
          <div className="bg-cool-gray h-[3px] w-auto mx-8 my-3 rounded-full"></div>
          <div
            className={`${themeValue === 'dark'
              ? 'text-raisin-black'
              : 'text-crystal-bell'
              } text-sm leading-6`}
          >
            <NavLink
              to="/my-profile"
              onClick={() => {
                setOpenSettings(false);
                setPowerPanelOpen(false);
              }}
              className={({ isActive }) =>
                `px-3 py-2 flex rounded-lg cursor-pointer items-center ${isActive
                  ? 'bg-nue-blue hover:bg-nue-blue/70 text-white transition'
                  : `${themeValue === 'dark'
                    ? 'text-crystal-bell hover:bg-ship-grey hover:text-tropical-indigo'
                    : 'text-raisin-black hover:bg-lavender hover:text-violet-blue'
                  }`
                }`
              }
              end
            >
              <li className="flex items-center justify-center">
                {store.profile.avatar?.svg ? (
                  <div className="avatar">
                    <div className="w-6 rounded">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: store.profile.avatar?.svg,
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <UserCircleIcon
                    className={`w-5 h-5 transition`}
                    to="/my-profile"
                  />
                )}
                <span className="origin-left duration-200 ml-2">
                  User settings
                </span>
              </li>
            </NavLink>

            <NavLink
              to="/transactions"
              onClick={() => {
                setOpenSettings(false);
                setPowerPanelOpen(false);
              }}
              className={({ isActive }) =>
                `px-3 py-2 flex rounded-lg cursor-pointer items-center ${isActive
                  ? 'bg-nue-blue hover:bg-nue-blue/70 text-white transition'
                  : `${themeValue === 'dark'
                    ? 'text-crystal-bell hover:bg-ship-grey hover:text-tropical-indigo'
                    : 'text-raisin-black hover:bg-lavender hover:text-violet-blue'
                  }`
                }`
              }
            >
              <li className="flex items-center justify-center">
                <ArrowsRightLeftIcon
                  className={`w-5 h-5 transition`}
                  to="/transactions"
                />
                <span className="origin-left duration-200 ml-2">
                  Transactions
                </span>
              </li>
            </NavLink>

            <NavLink
              to="/my-profile/pricing"
              onClick={() => {
                setOpenSettings(false);
                setPowerPanelOpen(false);
              }}
              end
              className={({ isActive }) =>
                `px-3 py-2 flex rounded-lg cursor-pointer items-center ${isActive
                  ? 'bg-nue-blue hover:bg-nue-blue/70 text-white transition'
                  : `${themeValue === 'dark'
                    ? 'text-crystal-bell hover:bg-ship-grey hover:text-tropical-indigo'
                    : 'text-raisin-black hover:bg-lavender hover:text-violet-blue'
                  }`
                }`
              }
            >
              <li className="flex items-center justify-center">
                <CreditCardIcon
                  to="/my-profile/pricing"
                  end
                  className={`w-5 h-5 transition`}
                />
                <span className="origin-left duration-200 ml-2">
                  Billing and plans
                </span>
              </li>
            </NavLink>

            <NavLink
              to="/rewards"
              onClick={() => {
                setOpenSettings(false);
                setPowerPanelOpen(false);
              }}
              className={({ isActive }) =>
                `px-3 py-2 flex rounded-lg cursor-pointer items-center ${isActive
                  ? 'bg-nue-blue hover:bg-nue-blue/70 text-white transition'
                  : `${themeValue === 'dark'
                    ? 'text-crystal-bell hover:bg-ship-grey hover:text-tropical-indigo'
                    : 'text-raisin-black hover:bg-lavender hover:text-violet-blue'
                  }`
                }`
              }
            >
              <li className="flex items-center justify-center">
                <TrophyIcon
                  className={`w-5 h-5 transition`}
                  to="/rewards"
                />
                <span className="origin-left duration-200 ml-2">
                  Rewards
                </span>
              </li>
            </NavLink>

            <div
              onClick={() => handleUserGuideOrModal()}
              className={`px-3 py-2 flex rounded-lg cursor-pointer items-center ${themeValue === 'dark'
                ? 'text-crystal-bell hover:bg-ship-grey hover:text-tropical-indigo'
                : 'text-raisin-black hover:bg-lavender hover:text-violet-blue'
                }`}
            >
              <li className="flex items-center justify-center">
                <UsersIcon className={`w-5 h-5 transition`} />
                <span className="origin-left duration-200 ml-2">
                  Teams
                </span>
              </li>
            </div>

            <div
              className={`px-3 py-2 flex rounded-lg cursor-pointer items-center ${themeValue === 'dark'
                ? 'text-crystal-bell hover:bg-ship-grey hover:text-tropical-indigo'
                : 'text-raisin-black hover:bg-lavender hover:text-violet-blue'
                }`}
            >
              <a
                href="https://straico.com/desktop-app/"
                target="_blank"
                rel="noreferrer"
              >
                <li className="flex items-center justify-center">
                  <ComputerDesktopIcon
                    className={`w-5 h-5 transition`}
                    to="/rewards"
                  />
                  <span className="origin-left duration-200 ml-2">
                    Desktop app
                    <p className="origin-left duration-200 text-[10px] -mt-[12px]">
                      Beta
                    </p>
                  </span>
                </li>
              </a>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Teams feature */}
      {showTeamsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 font-figtree">
          <div className="relative bg-white dark:bg-night-black p-6 rounded-2xl shadow-2xl max-w-md w-full text-center border border-platinum dark:border-ship-grey">
            <button
              onClick={() => setShowTeamsModal(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-white transition"
              aria-label="Close"
            >
              <XMarkIcon className="w-4 h-4" />
            </button>

            <div className="flex flex-col items-center space-y-4">
              <UsersIcon className="w-12 h-12 text-nue-blue dark:text-tropical-indigo" />
              <h2 className="text-xl font-semibold text-raisin-black dark:text-palladium">
                Centralize AI for Your Team.
              </h2>

              <p className="text-base font-medium text-nue-blue dark:text-tropical-indigo">
                Unlock generative AI power with a unified workspace.
              </p>

              <p className="text-sm text-gray-500 dark:text-gray-400">
                Simplify AI management, optimize costs,
                <br />
                and improve team productivity with Straico.
              </p>
              <div className="flex justify-center gap-4 w-full mt-6">
                <button
                  onClick={() =>
                    window.open('https://straico.com/teams', '_blank')
                  }
                  className="w-full py-2 rounded-lg bg-nue-blue text-white hover:bg-nue-blue/90 transition font-medium"
                >
                  Book a Demo
                </button>
                <button
                  onClick={() => setShowTeamsModal(false)}
                  className="w-full py-2 rounded-lg bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-white hover:bg-gray-300 dark:hover:bg-gray-600 active:bg-gray-400 dark:active:bg-gray-500 transition font-medium"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Dialogs */}
      {openDialogDiscord && (
        <DiscordModal onInteraction={onInteraction}></DiscordModal>
      )}
      {openDialogHelp && <HelpModal onInteraction={onInteraction}></HelpModal>}
      {openDialogShort && <ShortModal onInteraction={onInteraction} />}
    </>
  );
};

export default inject('store')(observer(ProfileMenu)); 